import React from 'react'
import { WidgetContent, Divider } from '@duik/it'
import CreateNewModal from '../UI/CreateNewModal'
import Dropzone from 'react-dropzone-uploader'
import 'react-dropzone-uploader/dist/styles.css'
import { ModalButton } from '../UI/ModalButton'

const UploadBackupModal = props => {
  // const handleChangeStatus = ({ meta }, status) => {
  //   console.log(status, meta)
  // }

  // const handleSubmit = (files, allFiles) => {
  //   console.log(files.map(f => f.meta))
  //   allFiles.forEach(f => f.remove())
  // }
  return (
    <CreateNewModal title="Upload Backup" handleCloseModal={props.uploadBackupModalToggle}>
      <WidgetContent style={{ maxHeight: '75%' }}>
        <Dropzone
          // getUploadParams={getUploadParams}
          onDrop={file => props.fileChangeDrop(file)}
          onChangeStatus={e => props.fileStatusChange(e)}
          inputContent="Drag and drop your file or click to upload"
          styles={{
            dropzone: { minHeight: '271px', maxHeight: '40vh' },
            preview: { padding: '30px' }
          }}
        />
      </WidgetContent>
      <Divider />
      <WidgetContent style={{ backgroundColor: '#FBFBFD', height: '51px' }}></WidgetContent>
      <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ width: '83px' }}>
          <ModalButton
            buttonStyle="tertiary"
            name="Cancel"
            onClick={props.uploadBackupModalToggle}
          />
        </div>
        <div style={{ width: '83px' }}>
          <ModalButton success onClick={() => props.uploadPitSlip(props._id)} name="Save" />
        </div>
      </WidgetContent>
    </CreateNewModal>
  )
}

export default UploadBackupModal
